/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { IVCSStrictHttpResponse } from '../../ivcs-strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface ConsumerPharmacistVerifiedGet$Json$Params {
}

export function consumerPharmacistVerifiedGet$Json(http: HttpClient, rootUrl: string, params?: ConsumerPharmacistVerifiedGet$Json$Params, context?: HttpContext): Observable<IVCSStrictHttpResponse<boolean>> {
  const rb = new RequestBuilder(rootUrl, consumerPharmacistVerifiedGet$Json.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: String((r as HttpResponse<any>).body) === 'true' }) as IVCSStrictHttpResponse<boolean>;
    })
  );
}

consumerPharmacistVerifiedGet$Json.PATH = '/Consumer/PharmacistVerified';
